import Title from './Title.styled'

export default Title
